import { MessagesContext } from "@/contexts/MessagesContext";
import { useContext } from "react";

export const useMessagesContext = () => {
  return useContext(MessagesContext);
};
